// @flow
import React from "react"
import PlusIcon from "assets/icons/PlusIcon"
import type { Profile } from "data/user/types"
import { AvatarWrap } from "./styled"

type Props = {|
  profile?: Profile,
  big?: boolean,
|}

const Avatar = ({ profile, big }: Props) => (
  <AvatarWrap big={big}>
    {profile ? `${profile.firstName[0]}${profile.lastName[0]}` : <PlusIcon />}
  </AvatarWrap>
)

export default Avatar



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js